import TableSkeleton from '../../../components/loaders/TableSkeleton';
import ListHeader from '../../../components/ListHeader';
import { useTranslation } from 'react-i18next';
import LeadsTableContainer from '../../../modules/leads/components/LeadsTableContainer';
import useModuleTableHelpers from '../../../hooks/useModuleTableHelpers';
import Button from '../../../components/buttons/Button';
import ExportExcel from '../../../components/buttons/ExportExcel/ExportExcel';


const Leads = () => {
    const { t } = useTranslation();

    const { apiData, apiDataLoading, paginationEle, searchEle } = useModuleTableHelpers({
        route: 'admin/leads',
        withBreadcrumb: true,
        withSearch: true,
        breadcrumbTitle: t('links.leads'),
        withPagination: true,
        queryKey: 'leads',
        customSearchPlaceholder: `${t("search_by")} ${t("name")}, ${t("mobile")} ${t("or")} ${t("email")}`
    });

    const tableHeaders = [
        { label: t('first_name') },
        { label: t('last_name') },
        { label: t('email') },
        { label: t('phone') },
        { label: t('assigned_sales') },
        { label: t('provider_lead_id') },
        { label: t('actions'), customClass: 'actions_col' }
    ].filter(Boolean);

    if (apiDataLoading && !apiData) return <TableSkeleton columns={6} withoutButton />;

    return (
        <div className="leads-page-container">
            <ListHeader customClass='table_filters'>
                <div className="filter_container">{searchEle}</div>
                {/* {hasPermission(['leeds.edit']) && <Button text={t('create_lead')} link="/leads/create-lead" />} */}
                <div style={{display: "flex", gap: "1rem"}}>
                    <ExportExcel endpoint='admin/leads/export' fileName='leads' />
                    {<Button text={t('create_lead')} link="/leads/create-lead" />}
                </div>
            </ListHeader>
            <LeadsTableContainer tableHeaders={tableHeaders} data={apiData} noDataMessage={t('no_leads_found')} lessColumns />
            {paginationEle}
        </div>
    );
};

export default Leads;
